/* eslint-disable react/require-default-props */
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import {
  Alert, Card, CardBody, Col, Container, Row,
} from 'reactstrap';

// Import Breadcrumb
import Breadcrumb from '../../components/Common/Breadcrumb';

import avatar from '../../assets/images/users/avatar-1.jpg';

class UserProfile extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: '',
      name: '',
      idx: 1,
      profile_image: null,
    };
  }

  componentDidMount() {
    if (localStorage.getItem('authUser')) {
      const obj = JSON.parse(localStorage.getItem('authUser'));
      if (process.env.REACT_APP_DEFAULTAUTH === 'firebase') {
        this.setState({
          name: obj.displayName,
          email: obj.email,
          idx: obj.uid,
          profile_image: obj.profile_image,
        });
      } else if (
        process.env.REACT_APP_DEFAULTAUTH === 'fake'
        || process.env.REACT_APP_DEFAULTAUTH === 'jwt'
      ) {
        this.setState({
          name: obj.username,
          email: obj.email,
          idx: obj.uid,
          profile_image: obj.profile_image,
        });
      }
    }
  }

  // eslint-disable-next-line no-unused-vars
  componentDidUpdate(prevProps, prevState, ss) {
    if (this.props !== prevProps) {
      const obj = JSON.parse(localStorage.getItem('authUser'));
      if (process.env.REACT_APP_DEFAULTAUTH === 'firebase') {
        this.setState({
          name: obj.displayName,
          email: obj.email,
          idx: obj.uid,
        });
      } else if (
        process.env.REACT_APP_DEFAULTAUTH === 'fake'
        || process.env.REACT_APP_DEFAULTAUTH === 'jwt'
      ) {
        this.setState({ name: obj.username, email: obj.email, idx: obj.uid });
      }
    }
  }

  render() {
    return (
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumb title="Skote" breadcrumbItem="Profile" />

          <Row>
            <Col lg="12">
              {this.props.error && this.props.error ? (
                <Alert color="danger">{this.props.error}</Alert>
              ) : null}
              {this.props.success && this.props.success ? (
                <Alert color="success">{this.props.success}</Alert>
              ) : null}

              <Card>
                <CardBody>
                  <div className="d-flex">
                    <div className="me-3">
                      {this.state.profile_image === null && (
                        <img
                          src={avatar}
                          alt=""
                          className="avatar-md rounded-circle img-thumbnail"
                        />
                      )}

                      {this.state.profile_image !== null && (
                        <img
                          src={this.state.profile_image}
                          alt=""
                          className="avatar-md rounded-circle img-thumbnail"
                        />
                      )}
                    </div>
                    <div className="align-self-center flex-1">
                      <div className="text-muted">
                        <h5>{this.state.name}</h5>
                        <p className="mb-1">{this.state.email}</p>
                        <p className="mb-0">
                          Id no: #
                          {this.state.idx}
                        </p>
                      </div>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}

UserProfile.propTypes = {
  error: PropTypes.any,
  success: PropTypes.any,
};

export default UserProfile;
